<template>
  <modal
    class="snapshot-modal"
    :visible="visible"
    :title="filename"
    can-close
    @close="close"
  >
    <template v-slot:body>
      <canvas ref="snapshot" class="snapshot-image" />
    </template>

    <template v-slot:footer>
      <el-button type="danger" @click="close">
        Cancel
      </el-button>
      <el-button @click="downloadSnapshot">
        Download
      </el-button>
    </template>
  </modal>
</template>

<script>
/** vuex */
import { mapState } from "vuex";
import { getAPI, token } from "@/api/params.js";
import Modal from "@/components/dialog/Modal.vue";
import { drawSnapshot, downloadCanvasImage } from "@/utils/snapshot.js";

import snapshotSoundFile from "@/assets/sounds/snapshot_sound.mp3";

// @group Snapshot
// Snapshot panel
export default {
  name: "SnapshotModal",
  components: {
    Modal
  },
  props: {
    // snapshot source video
    player: {
      type: HTMLVideoElement,
      default: null
    },
    // is modal shown
    visible: {
      type: Boolean,
      required: true
    },
    // snapshot filename without extension
    filename: {
      type: String,
      default: "snapshot"
    }
  },
  computed: {
    ...mapState({
      timePlayer: state => state.ndvrPlayer.displayTimer,
      stream: state => state.services.stream
    })
  },
  data() {
    return {
      snapshotSound: null
    };
  },
  watch: {
    // @vuese
    // Create snapshot and play snapshot-sound when modal is opened
    visible(val) {
      if (val) {
        try {
          this.snap();
          this.snapshotSound.play(); // play sound effect
        } catch (err) {
          this.$notify({
            group: "foo",
            position: "bottom right",
            type: "error",
            title: "Snapshot Failed",
            text: err
          });
          this.close();
        }
      }
    }
  },
  mounted() {
    /** add snapshot sound file */
    this.snapshotSound = new Audio(snapshotSoundFile);
  },
  methods: {
    // @vuese
    // Close panel
    close() {
      this.$emit("close");
    },
    // @vuese
    // Take snapshot and draw it on canvas
    snap() {
      const canvas = this.$refs.snapshot;
      drawSnapshot(this.player, canvas);
    },
    // @vuese
    // Download snapshot to file system
    downloadSnapshot() {
      //for admin logs
      const stream = this.stream;
      const timePlayer = this.timePlayer;
      fetch(`${getAPI()}/action-logs/log-snapshot?token=${token}`, {
        method: "POST",
        body: JSON.stringify({ stream, timePlayer }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token
        }
      });
      const canvas = this.$refs.snapshot;
      downloadCanvasImage(canvas, this.filename);
    },
    // @vuese
    // Disable mouse clicks when panel is opened
    handleContainerClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
};
</script>

<style>
.snapshot-modal .modal {
  width: 50%;
}

@media only screen and (max-width: 400px) {
  .snapshot-modal .modal {
    width: 90%;
  }
}

@media only screen and (max-width: 992px) {
  .snapshot-modal .modal {
    width: 70%;
  }
}
</style>

<style scoped>
.snapshot-image {
  width: 100%;
}
</style>
